import _ from "lodash";
import moment from "./moment";

function getIndex(date, start = null) {
  var hours = moment(date).format("H");
  var minutes = moment(date).format("m") / 60;
  var result = (+hours + minutes) * 2;
  if (start) {
    if (moment(date).diff(start, "hours") == 24 && result == 0) {
      result = 48;
    }
  }
  return result;
}

const formatSchedule = order => ({
  startDate: moment(order.startAt).format("MMMM D, YYYY"),
  startTime: getIndex(order.startAt).toString(),
  endDate: moment(order.endAt).format("MMMM D, YYYY"),
  endTime: getIndex(order.endAt, order.startAt).toString()
});

const overlap = (onCart, newBooking, id, index) => {
  onCart = _.filter(onCart, (range, i) => {
    if (!range) return;
    return range.Product.id === id && i !== index;
  });
  var dateRanges = [...onCart, ...newBooking];

  var sortedRanges = dateRanges.sort(function(previous, current) {
    var previousTime = previous.OrderPackage.startAt;
    var currentTime = current.OrderPackage.startAt;

    if (moment(previousTime).isBefore(moment(currentTime))) {
      return -1;
    }
    if (moment(previousTime).isSame(moment(currentTime))) {
      return 0;
    }
    return 1;
  });

  var result = sortedRanges.reduce(
    function(result, current, idx, arr) {
      if (idx === 0) {
        return result;
      }
      var previous = arr[idx - 1];

      var previousEnd = previous.OrderPackage.endAt;
      var currentStart = current.OrderPackage.startAt;

      var overlap = moment(previousEnd).isAfter(moment(currentStart));
      if (overlap) {
        result.overlap = true;
        result.ranges.push({
          previous: previous,
          current: current
        });
      }

      return result;
    },
    { overlap: false, ranges: [] }
  );

  return result;
};

export { formatSchedule, overlap };
